import { useQuery } from "@tanstack/react-query";
import { api, fmtDateTime } from "@/lib/api";
import { Panel, StatusBadge } from "@/components/admin/AdminLayout";

const Trigger = ({ label, t, testid }) => (
  <div className="flex items-center gap-2 text-sm" data-testid={testid}>
    <span className={`h-2.5 w-2.5 rounded-full ${t?.healthy ? "bg-emerald-500" : "bg-amber-400"}`} />
    <b>{label}</b>
    <span className="text-slate-500">{t?.last_tick_at ? `last check ${fmtDateTime(t.last_tick_at)}` : "no check received yet"}</span>
  </div>
);

export const SchedulerHealth = () => {
  const { data } = useQuery({ queryKey: ["scheduler-status"], queryFn: () => api.get("/admin/scheduler/status").then((r) => r.data), refetchInterval: 60000 });
  if (!data) return null;
  const daily = data.jobs.filter((j) => ["import_feeds", "daily_digest", "expire_stale"].includes(j.key));
  return (
    <Panel title="Scheduler health" testid="scheduler-health">
      <div className="space-y-2 mb-4">
        <Trigger label="Outside scheduler (every 15 min)" t={data.outside_cron} testid="scheduler-outside" />
        <Trigger label="In-app backup (every minute)" t={data.in_app} testid="scheduler-inapp" />
        <p className="text-xs text-slate-500">Both use the same lock, so each job runs once per slot even if both fire. Times are India time ({data.timezone}).</p>
      </div>
      <table className="w-full text-sm" data-testid="scheduler-jobs">
        <thead><tr className="text-left text-slate-500"><th className="p-2">Job</th><th className="p-2">Last success</th><th className="p-2">Last run</th><th className="p-2">Next run</th></tr></thead>
        <tbody>
          {daily.map((j) => (
            <tr key={j.key} className="border-t border-slate-100" data-testid={`scheduler-job-${j.key}`}>
              <td className="p-2 font-medium">{j.name}{!j.enabled && <span className="text-xs text-slate-400"> (off)</span>}</td>
              <td className="p-2">{j.last_success_at ? fmtDateTime(j.last_success_at) : "—"}</td>
              <td className="p-2">{j.last_run_at ? <>{fmtDateTime(j.last_run_at)} <StatusBadge s={j.last_status} /></> : "never"}</td>
              <td className="p-2">{j.enabled ? fmtDateTime(j.next_run_at) : "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Panel>
  );
};
